import { render, staticRenderFns } from "./vime_activity_assistance_new_modal.vue?vue&type=template&id=0d08d77e"
import script from "./vime_activity_assistance_new_modal.vue?vue&type=script&lang=js"
export * from "./vime_activity_assistance_new_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports